module.exports = __webpack_public_path__ + "white.webp?686fb00e2029db6e51ce07a37c83aa83";